import { defineRecipe } from '@chakra-ui/react'

export const buttonRecipe = defineRecipe({
  base: {
    borderRadius: 'button',
    fontWeight: 'semibold',
    transition: 'all 0.2s',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'body',
  },
  variants: {
    variant: {
      'acp-primary': {
        bg: 'acp.blue',
        color: 'white',
        _hover: { bg: 'acp.blueLight', color: 'white' },
        _active: { bg: '#045a94' },
      },
      // Extruded "press" button — the brand's primary CTA (see landing-mockup).
      // The 4px solid drop shadow (blueStrong #034a7c) gives the keycap look;
      // pressing translates down onto a 1px shadow.
      'acp-press': {
        bg: 'acp.bluePress',
        color: 'white',
        boxShadow: '0 4px 0 0 #034a7c',
        _hover: { bg: 'acp.blue', color: 'white' },
        _active: { transform: 'translateY(3px)', boxShadow: '0 1px 0 0 #034a7c' },
      },
      'acp-secondary': {
        bg: 'acp.gold',
        color: 'white',
        _hover: { bg: '#d4a91e' },
        _active: { bg: '#a8820f' },
      },
      'acp-outline': {
        borderWidth: '1px',
        borderColor: 'acp.blue',
        color: 'acp.blue',
        bg: 'transparent',
        _hover: { bg: 'acp.blue', color: 'white' },
        _active: { bg: '#045a94' },
      },
      'acp-ghost': {
        color: 'acp.blue',
        bg: 'transparent',
        _hover: { bg: 'acp.bgSoft' },
        _active: { bg: 'acp.bg' },
      },
      'acp-danger': {
        bg: 'red.500',
        color: 'white',
        _hover: { bg: 'red.600' },
        _active: { bg: 'red.700' },
      },
      'acp-success': {
        bg: 'green.600',
        color: 'white',
        _hover: { bg: 'green.700' },
        _active: { bg: 'green.800' },
      },
    },
  },
})

export const badgeRecipe = defineRecipe({
  base: {
    borderRadius: 'full',
    fontWeight: 'semibold',
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    px: 2,
    py: 0.5,
    fontSize: 'xs',
    fontFamily: 'body',
  },
  variants: {
    variant: {
      'acp-draft': { bg: 'orange.100', color: 'orange.800' },
      'acp-published': { bg: 'green.100', color: 'green.800' },
      'acp-tag': { bg: 'blue.50', color: 'acp.blue' },
      'acp-pending': { bg: 'gray.100', color: 'gray.600' },
      'acp-starting': { bg: 'blue.50', color: 'blue.600' },
      'acp-running': { bg: 'blue.100', color: 'blue.700' },
      'acp-waiting': { bg: 'yellow.100', color: 'yellow.700' },
      'acp-completed': { bg: 'green.100', color: 'green.700' },
      'acp-failed': { bg: 'red.100', color: 'red.700' },
      'acp-stopped': { bg: 'gray.100', color: 'gray.500' },
      'acp-gold': { bg: '#fef3c7', color: '#92400e' },
      'acp-info': { bg: 'blue.50', color: 'acp.blue' },
    },
  },
})
